import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_STUDENT_DROP_OUT_BY_TYPE } from "../Schema/Dashboard";

const useGetStudentDropoutByType = ({ filterType, date }) => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  // console.log("filterType::", filterType)

  const { refetch } = useQuery(GET_STUDENT_DROP_OUT_BY_TYPE, {
    variables: {
      filterType,
      date,
    },
    onCompleted: ({ getTotalStudentDroupout }) => {
      setTableData(getTotalStudentDroupout || []);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [filterType, date]);

  return { tableData, loading };
};

export default useGetStudentDropoutByType;
